import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SetGuardianReceivesEmailsMutation = graphql.persisted(
  "SetGuardianReceivesEmails",
  graphql(`
    mutation SetGuardianReceivesEmails($familyId: ID!, $personId: ID!, $receivesEmails: Boolean!) {
      setGuardianReceivesEmails(input: { familyId: $familyId, personId: $personId, receivesEmails: $receivesEmails }) {
        errors
      }
    }
  `)
);

export { SetGuardianReceivesEmailsMutation };

export function useSetGuardianReceivesEmails() {
  return useMutation(SetGuardianReceivesEmailsMutation);
}
